import { render, staticRenderFns } from "./RmrToggleCard.vue?vue&type=template&id=643ac60d&scoped=true&"
import script from "./RmrToggleCard.vue?vue&type=script&lang=js&"
export * from "./RmrToggleCard.vue?vue&type=script&lang=js&"
import style0 from "./RmrToggleCard.vue?vue&type=style&index=0&id=643ac60d&lang=scss&scoped=true&"
import style1 from "./RmrToggleCard.vue?vue&type=style&index=1&id=643ac60d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643ac60d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
